import { api } from '@fastcampus/browser-support';

const config = {
  headers: { 'cache-control': 'no-cache', Pragma: 'no-cache' },
};

export default {
  getProductById(productId) {
    return api.get(`/www/products/${productId}`);
  },
  getProductsByIds(pageId, productsIds) {
    const productIds = productsIds.map((pid) => `id=${pid}`).join('&');

    try {
      return api.get(`/www/pages/${pageId}/products?${productIds}`);
    } catch (e) {
      return new Error(e);
    }
  },
  findCourseProductsToSale(params) {
    const url = `/www/courses/${params.courseId}/products`;
    try {
      return api.get(url);
    } catch (err) {
      throw new Error(err);
    }
  },
  findCoursesByIds(coursesIds) {
    const courseIds = coursesIds.map((courseId) => `id=${courseId}`).join('&');

    try {
      return api.get(`/www/courses?${courseIds}`);
    } catch (err) {
      throw new Error(err);
    }
  },
  getCoupons(codes) {
    const url = `/www/coupons?${codes}`;
    try {
      return api.get(url, config);
    } catch (err) {
      throw new Error(err);
    }
  },
  requestCoupons(params) {
    const url = `/www/coupons/redeems`;
    try {
      return api.put(url, {
        redeemCodes: params,
      });
    } catch (err) {
      throw new Error(err);
    }
  },
  getUserInfo() {
    try {
      return api.get(`/www/users/myinfo/coupon`, config);
    } catch (err) {
      throw err;
    }
  },
  getRouletteByRoulette(code, pageId) {
    try {
      return api.get(`/www/coupons/roulette?code=${code}&pageId=${pageId}`, config);
    } catch (err) {
      throw err;
    }
  },
  async requestUserRedeemByRoulette(code) {
    try {
      return await api.put(`/www/coupons/roulette`, {
        code,
      });
    } catch (err) {
      throw err;
    }
  },
};
